import React from 'react';
import NavigateMenu from "components/NavigateMenu";
import {Box, Container} from "@mui/material";
import RenderSuggestion from "components/RenderSuggestion";
import Seo from 'components/Seo';
import { t } from 'i18next';

function HomePage() {
  return (
    <Container>
      <Seo title={t("meta.home.title")} description={t("meta.home.desc")} />
      {/* <Seo titleKey="meta.home.title" descKey="meta.home.desc" /> */}
      <NavigateMenu mt={4}/>
      <Box py={10} pt={{xs: 3, md: 10}}>
        <RenderSuggestion/>
      </Box>

    </Container>
  );
}

export default HomePage;
